// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Amex: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            height="22"
            viewBox="0 0 27 22"
            fill="currentColor"
        >
            <path
                fill="#333"
                d="M452.25,911.5 C451.007344,911.5 450,910.492188 450,909.25 L450,892.75 C450,891.507343 451.007344,890.5 452.25,890.5 L474.75,890.5 C475.992188,890.5 477,891.507343 477,892.75 L477,892.863906 L473.460938,892.863906 L472.664062,895.09375 L471.871875,892.863906 L467.315625,892.863906 L467.315625,895.825 L465.998437,892.863906 L462.314063,892.863906 L458.484375,901.520313 L461.56875,901.520313 L461.56875,909.198437 L471.117188,909.198437 L472.6125,907.553124 L474.107812,909.198437 L477,909.198437 L477,909.25 C477,910.492188 475.992188,911.5 474.75,911.5 L452.25,911.5 Z M472.621875,906.0625 L470.64375,908.232812 L468.304688,908.232812 L471.46875,904.871875 L468.304688,901.473438 L470.714062,901.473438 L472.659375,903.662499 L474.628126,901.473438 L477,901.473438 L473.8125,904.853126 L477,908.232812 L474.590624,908.232812 L472.621875,906.0625 Z M477,902.917187 L477,906.821876 L475.157813,904.857812 L477,902.917187 Z M464.41875,906.676563 L468.309375,906.676563 L468.309375,908.232812 L462.590625,908.232812 L462.590625,901.520313 L468.309375,901.520313 L468.309375,903.071876 L464.41875,903.071876 L464.41875,904.121875 L468.210938,904.121875 L468.210938,905.635937 L464.41875,905.635937 L464.41875,906.681251 L464.41875,906.676563 Z M475.185937,895.829688 L473.45625,900.545313 L471.84375,900.545313 L470.118751,895.84375 L470.118751,900.545313 L468.304688,900.545313 L468.304688,893.828125 L471.173438,893.828125 L472.66875,898.014063 L474.178124,893.828125 L477,893.828125 L477,900.545313 L475.185937,900.545313 L475.185937,895.829688 Z M465.679688,899.2 L462.590625,899.2 L462.032813,900.545313 L460.017187,900.545313 L462.942188,893.828125 L465.342187,893.828125 L468.309375,900.545313 L466.242188,900.545313 L465.679688,899.2 Z M464.132812,895.492188 L463.21875,897.690625 L465.042187,897.690625 L464.132812,895.492188 Z"
                transform="translate(-450 -890)"
            />
        </svg>
    );
};

export default React.memo(Amex);
